import * as React from 'react';
import { getSurveyActivities } from '../../../api/activityClientApi';
import { appUrlBuilder } from '../../../utils/appUrlBuilder';
import { DashboardCard } from './DashboardCard';
import { DashboardCardContent } from './DashboardCardContent';



export function DashboardWorkplaceAssessmentCard(): JSX.Element {

    const [workplaceAssessments, setWorkplaceAssessments] = React.useState([]);
    const [status, setStatus] = React.useState("")
    
    React.useEffect(()=>{
        const getData = async () => {
            const activities = await getSurveyActivities('WorkplaceAssessment');
            const now = new Date();
                        
            const activitiesPresent = activities
                .filter(a => new Date(a.start) <= now && new Date(a.end) >= now)
                .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
            
            const futureActivities = activities
                .filter(a => a.start && new Date(a.start) > now)
                .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());

            if(activitiesPresent.length > 0){
                setStatus("present");
                setWorkplaceAssessments(activitiesPresent);
                return;
            } else {
                setStatus("future");
                setWorkplaceAssessments(futureActivities);
            }
        };
        getData();

    },[])

    return (
        <DashboardCard backgroundColor="white">
            {workplaceAssessments.length > 0 ? (
                <DashboardCardContent 
                    title="Arbejdspladsvurdering 1"
                    activityStatus={status === "present" ? `Nuværende arbejdspladsvurdering ${workplaceAssessments[0].start.toLocaleDateString()} - ${workplaceAssessments[0].end.toLocaleDateString()}` : `Kommende arbejdspladsvurdering ${workplaceAssessments[0].start.toLocaleDateString()} - ${workplaceAssessments[0].end.toLocaleDateString()}`}
                    activityLink={appUrlBuilder.workPlaceAssessment.internal(workplaceAssessments[0].id)}
                    activityTitle={workplaceAssessments[0].title}
                    icon='assignment'
                />
            ) : (
                <DashboardCardContent 
                    title="Arbejdspladsvurdering 2"
                    activityStatus="Ingen kommende arbejdspladsvurderinger"
                    activityLink={appUrlBuilder.workPlaceAssessment.list()}
                    activityTitle="Opret en arbejdspladsvurdering"
                    createNew={true}
                    icon='assignment'
                />
            )}
        </DashboardCard>
    );
}